var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 20.3718,
    r: 19.822,
    fill: "#CD2A3F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_7179)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1777 28.5488C12.3821 28.5488 11.619 28.2328 11.0564 27.6701C10.4938 27.1075 10.1777 26.3445 10.1777 25.5488V15.5488C10.1777 14.7532 10.4938 13.9901 11.0564 13.4275C11.619 12.8649 12.3821 12.5488 13.1777 12.5488H27.1777C27.9734 12.5488 28.7364 12.8649 29.2991 13.4275C29.8617 13.9901 30.1777 14.7532 30.1777 15.5488V25.5488C30.1777 26.3445 29.8617 27.1075 29.2991 27.6701C28.7364 28.2328 27.9734 28.5488 27.1777 28.5488H13.1777ZM15.8027 16.7688C15.7009 16.6818 15.5826 16.6162 15.4548 16.5758C15.3271 16.5354 15.1926 16.5211 15.0592 16.5337C14.9259 16.5464 14.7964 16.5856 14.6785 16.6492C14.5607 16.7128 14.4567 16.7995 14.373 16.904C14.2892 17.0085 14.2273 17.1288 14.1909 17.2577C14.1546 17.3867 14.1445 17.5216 14.1612 17.6545C14.178 17.7874 14.2213 17.9155 14.2885 18.0314C14.3558 18.1472 14.4456 18.2484 14.5527 18.3288L18.3027 21.3298C18.8348 21.7558 19.4961 21.988 20.1777 21.988C20.8594 21.988 21.5206 21.7558 22.0527 21.3298L25.8027 18.3298C25.9053 18.2478 25.9907 18.1463 26.054 18.0312C26.1174 17.9161 26.1574 17.7897 26.1719 17.6591C26.1864 17.5286 26.175 17.3964 26.1385 17.2703C26.1019 17.1441 26.0408 17.0264 25.9587 16.9238C25.8767 16.8213 25.7752 16.7359 25.6601 16.6725C25.545 16.6092 25.4186 16.5691 25.288 16.5546C25.1575 16.5402 25.0253 16.5515 24.8992 16.5881C24.773 16.6247 24.6553 16.6858 24.5527 16.7678L20.8027 19.7678C20.6254 19.9098 20.4049 19.9872 20.1777 19.9872C19.9505 19.9872 19.7301 19.9098 19.5527 19.7678L15.8027 16.7678V16.7688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_7179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.205,
    height: 21.205,
    fill: "white",
    transform: "translate(9.39697 9.76855)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeEmailIcon);
export default __webpack_public_path__ + "static/media/changeEmailIcon.89d8e8fb436f549b8816b905494b0789.svg";
export { ForwardRef as ReactComponent };